module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }), _vm._v(" "), _c('main', {
    staticClass: "wrapper-404"
  }, [_c('div', {
    staticClass: "error-404"
  }, [_c('h1', [_vm._v("\n            页面飞到外太空了~~找不回来啦\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "error-number"
  }, [_c('span', [_vm._v("4")]), _c('span', [_c('img', {
    staticClass: "icon has-animation",
    attrs: {
      "src": "https://image.flaticon.com/icons/svg/179/179595.svg",
      "alt": ""
    }
  })]), _c('span', [_vm._v("4")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-29c6e2c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/dashboard/404.vue
// module id = 449
// module chunks = 2